import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { Code } from "@/molecules/Code"
import {
  getGatewayTagCommand,
  getRoleTagCommand
} from "@/pages/DeploymentsPage/application/useAgentPlatform.selector"

import type { AgentCoreTagCommandsProps } from "."

const TAG_STEPS = [
  { step: "gateway", getCommand: getGatewayTagCommand },
  { step: "role", getCommand: getRoleTagCommand }
] as const

// The two tagging steps: each gateway Kodem may control, then each role (the
// gateways' and the agents' Kodem may block), each with its command
export const AgentCoreTagCommands = ({
  controlTag
}: AgentCoreTagCommandsProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "deployments.agentCore.cloud.fields.roleTag.steps"
  })

  return TAG_STEPS.map(({ step, getCommand }, index) => {
    const command = getCommand(controlTag)

    return (
      command && (
        <Flex key={step} vertical gap={8}>
          <Text strong>{t(`${step}.title`, { number: index + 1 })}</Text>
          <Text type="secondary">{t(`${step}.instructions`)}</Text>
          <Code.CommandCard>
            <Code.CommandSnippet
              instruction=""
              commands={command}
              copyText={command}
            />
          </Code.CommandCard>
        </Flex>
      )
    )
  })
}
